import React, { useState } from 'react';
import { Typography, Grid } from '@mui/material'
import DropdownSelector from './components/DropdownSelector';
import SalaryDataView from './components/SalaryDataView';
import CalculationsCard from './components/CalculationsCard';
import { Grade, Period, Scheme } from './api-client';
import { DropdownIdentifier } from './constants';
import {UcamHeader} from '@ucam.uis.devops/mui-theme'
import HomeLayout from "@ucam.uis.devops/mui-theme/layouts/home";


const App: React.FC = () => {
  const [selectedGrade, setSelectedGrade] = useState(null as Grade | null)
  const [selectedPeriod, setSelectedPeriod] = useState(null as Period | null)
  const [selectedScheme, setSelectedScheme] = useState(null as Scheme | null)

  return (
    <>
      <UcamHeader title="Salary On-Costs Service" />
      <main>
        <HomeLayout>
          <Grid container spacing={{xs: 4, sm: 4, md: 4, lg: 4, xl: 4}}>
            <Grid size={12}>
              <Typography variant="h5" align="center">
                Salary scales including on-costs
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={{xs: 4, sm: 4, md: 4, lg: 4, xl: 4}} sx={{mt: 5}}>
            <Grid size={{xs: 12, sm: 6, md: 4, lg: 4, xl: 4}}>
              <DropdownSelector<Scheme>
                label="Scheme"
                dropdownIdentifier={DropdownIdentifier.Scheme}
                defaultValue="USS"
                onChange={setSelectedScheme} />
            </Grid>
          </Grid>
          <Grid container sx={{mt: 5}} spacing={{xs: 4, sm: 4, md: 4, lg: 4, xl: 4}}>
            <Grid size={{xs: 12, sm: 6, md: 4, lg: 4, xl: 4}}>
              <DropdownSelector<Period>
                label="Period"
                dropdownIdentifier={DropdownIdentifier.Period}
                onChange={setSelectedPeriod} />
            </Grid>
            <Grid size={{xs: 12, sm: 6, md: 4, lg: 4, xl: 4}}>
              <DropdownSelector<Grade>
                label="Grade"
                dropdownIdentifier={DropdownIdentifier.Grade}
                onChange={setSelectedGrade} />
            </Grid>
          </Grid>
          <Grid container sx={{mt: 5}}>
            <Grid size={12}>
              <SalaryDataView
                scheme={selectedScheme}
                grade={selectedGrade}
                period={selectedPeriod}
                />
            </Grid>
          </Grid>
          <Grid container sx={{mt: 5}}>
            <Grid size={12}>
              <CalculationsCard
                period={selectedPeriod}
                scheme={selectedScheme} />
            </Grid>
          </Grid>
        </HomeLayout>
      </main>
    </>
  );
}

export default App;
